import { defineMessages } from "react-intl";

export const PANEL_MESSAGES = defineMessages({
  wrongAccountError: {
    id: "funding-application: air bank statement panel wrong account error",
    defaultMessage: "This statement is for a different account. Remove it and upload one for this account.",
  },
  cannotProvideNoteLabel: {
    id: "funding-application: air bank statement panel cannot provide note label",
    defaultMessage: "Add more context for our team",
  },
  cannotProvideLabel: {
    id: "funding-application: air bank statement panel cannot provide label",
    defaultMessage: "I have no more banking data to provide.",
  },
  cannotProvideConsequence: {
    id: "funding-application: air bank statement panel cannot provide consequence",
    defaultMessage:
      "At least one of your accounts needs {months} months of continuous banking data for us to continue with your funding application.",
  },
  incompleteCoverageError: {
    id: "funding-application: air bank statement panel incomplete coverage error",
    defaultMessage: "Add statements to cover the gaps or tick the box if you cannot provide them.",
  },
  filesStillReadingError: {
    id: "funding-application: air bank statement panel files still reading error",
    defaultMessage: "We are still processing your files. Wait a moment, then confirm.",
  },
  inProgressTag: {
    id: "funding-application: air bank statement panel in progress tag",
    defaultMessage: "In progress",
  },
  checkingUploads: {
    id: "funding-application: air bank statement panel checking uploads",
    defaultMessage:
      "One moment, we're checking your uploads to see if they're ready for our team. You'll see the result here in a few seconds.",
  },
  uploadingStatements: {
    id: "funding-application: air bank statement panel uploading statements",
    defaultMessage: "Uploading statements...",
  },
  createdFooter: {
    id: "funding-application: air bank statement panel created footer",
    defaultMessage: "Request created by Wayflyer · {date}",
  },
});
